import { render, staticRenderFns } from "./PropertyPlanView.vue?vue&type=template&id=82c57074&scoped=true&"
import script from "./PropertyPlanView.vue?vue&type=script&lang=ts&"
export * from "./PropertyPlanView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c57074",
  null
  
)

export default component.exports